import * as React from "react";
import i18n from "i18n";
import ErrorWidget from "./ErrorWidget";
export default class WidgetErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return { error };
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { error } = this.state;
    const { children, ...rest } = this.props;
    const childrenWithProps = React.cloneElement(children, rest);
    return error ? /* @__PURE__ */ React.createElement(
      ErrorWidget,
      {
        title: i18n.t("widget_errors.render_error", { ns: "widgets" }),
        errors: [{ description: error.toString() }]
      }
    ) : childrenWithProps;
  }
}
